import React, { useEffect, useState, useRef } from 'react';
import {
  external1,
  //  account_step, account_step2, account_step3, account_step4,
  card_vector, carduser1, carduser2, carduser3, onestart, start, circletik, clients, workright,
  billing, about_left_img, based, np, academic, accounts, dental, consulting, emr, finacess, severices, dottesti, rcmapart,
  internal,
  twoperson,
} from '../../../assets/images';
import { Accordion, Button, Card, Modal, Container, Col, Row, } from 'react-bootstrap';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js'; // Optional if you want to use icons
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../../config/api';
import { FaPlus, FaMinus } from "react-icons/fa";
const testimonials = [
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
];

const practiceSettings = [
  {
    number: "01",
    title: "Clinic- or Health System-Affiliated",
    description:
      "Manage complex integrations and multi-specialty workflows with a partner experienced in internal medicine billing within large healthcare systems ensuring accurate coding, timely reimbursements, and seamless EHR alignment.",
    icon: based, // Replace with correct path
    alt: "Hospital icon"
  },
  {
    number: "02",
    title: "Private Practice",
    description:
      "Take full control of your revenue with billing and RCM solutions that reduce administrative burden, improve claim accuracy, and streamline operations so you can focus on comprehensive patient care.",
    icon: np, // Replace with correct path
    alt: "Independent practice icon"
  },
  {
    number: "03",
    title: "University-Affiliated or Academic Settings",
    description:
      "Support academic internal medicine programs with billing strategies tailored to teaching hospitals, research-based care models, and compliance with institutional policies enabling data transparency and operational efficiency.",
    icon: academic, // Replace with correct path
    alt: "University icon"
  }
];

const familyMedicineServices = [
  {
    title: "Accounts Receivable",
    description:
      "Let us manage your A/R to improve cash flow stability and reduce aging balances across chronic and preventive care billing.",
    icon: accounts, // Replace with actual icon path
    alt: "Accounts Receivable Icon"
  },
  {
    title: "Collections & Denial Management",
    description:
      "Boost claim success rates by minimizing denials and identifying billing gaps common in internal medicine workflows.",
    icon: dental,
    alt: "Collections & Denial Icon"
  },
  {
    title: "Consulting & Practice Optimization",
    description:
      "Partner with internal medicine billing experts to streamline practice operations, optimize reimbursements, and uncover revenue opportunities.",
    icon: consulting,
    alt: "Consulting Icon"
  },
  {
    title: "EHR & System Integration",
    description:
      "Ensure seamless data flow and documentation accuracy with tailored integration support across your internal medicine systems.",
    icon: emr,
    alt: "EHR Integration Icon"
  },
  {
    title: "Financial Analysis & Reporting",
    description:
      "Make data-driven decisions with custom financial reporting aligned to internal medicine KPIs like visit frequency, chronic care coding, and payer performance.",
    icon: finacess,
    alt: "Financial Analysis Icon"
  },
  {
    title: "Specialized Medical Billing Services",
    description:
      "Access specialty-specific billing support for E/M services, chronic care management, wellness visits, and diagnostics all under one solution.",
    icon: severices,
    alt: "Medical Billing Icon"
  }
];


const InternalMedicine = () => {
  const sectionRefs = useRef([]);
  const containerRef = useRef();

  // Event tracking function
  const trackEvent = (action, category, label, location) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        custom_parameter_1: location
      });
    }
  };

  // Event handlers
  const handleServiceClick = (serviceName) => {
    trackEvent('click', 'Internal Medicine Services', serviceName, 'services_section');
  };

  const handlePracticeSettingClick = (settingName) => {
    trackEvent('click', 'Internal Medicine Practice Settings', settingName, 'practice_settings_section');
  };

  const handleCTAClick = (location) => {
    trackEvent('click', 'Internal Medicine CTA', 'Lets Connect', location);
  };

  const [animatedSections, setAnimatedSections] = useState(new Set());
  const CARD_WIDTH =
    window.innerWidth < 768
      ? 335
      : window.innerWidth < 1024
        ? 350
        : window.innerWidth < 1200
          ? 400
          : window.innerWidth < 1500
            ? 450
            : window.innerWidth < 1700
              ? 500
              : window.innerWidth < 1800
                ? 568
                : 625;
  const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];

  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 3) {
    groupedTestimonials.push(testimonials.slice(i, i + 3));
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3.5);

  const updateVisibleCards = () => {
    if (window.innerWidth < 1024) {
      setVisibleCards(1);
    } else {
      setVisibleCards(3.5);
    }
  };

  const [activeKey, setActiveKey] = useState("0");

  const toggleKey = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const animatedOnce = useRef(new Set());

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.sectionIndex;
          if (index && entry.isIntersecting && !animatedOnce.current.has(parseInt(index))) {
            setAnimatedSections(prev => new Set([...prev, parseInt(index)]));
            animatedOnce.current.add(parseInt(index));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      window.removeEventListener('resize', updateVisibleCards);
      observer.disconnect();
    };
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < testimonials.length - visibleCards ? prevIndex + 1 : prevIndex
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setIsSubmitted(false);
  };
  const handleShow = () => setShowModal(true);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const handleAccordionToggle = (eventKey) => {
    setActiveAccordion(prev => (prev === eventKey ? null : eventKey));
  }
  // const getImageToShow = () => {
  //   switch (activeAccordion) {
  //     case "0":
  //       return account_step2;
  //     case "1":
  //       return account_step3;
  //     case "2":
  //       return account_step4;
  //     case "3":
  //       return account_step5;
  //     default:
  //       return account_step;
  //   }
  // };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange", // Enables real-time validation
  });
  const [activeKey2, setActiveKey2] = useState("0");

  const toggleKey2 = (key) => {
    setActiveKey2(activeKey2 === key ? null : key);
  };
  const [navbarColor, setNavbarColor] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(getContactApiUrl(), {
        fullName: data.fullName,
        email: data.email,
        subject: data.subject || 'Contact Form Submission',
        message: data.message,
      });
      if (response.data.success) {
        setIsSubmitted(true);
        reset();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);

    const changeNavbarColor = () => {
      if (window.scrollY >= 80) {
        setNavbarColor(true);
      } else {
        setNavbarColor(false);
      }
    };
    window.addEventListener('scroll', changeNavbarColor);
    return () => {
      window.removeEventListener('scroll', changeNavbarColor);
    };
  }, []);
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = testimonials.length - Math.floor(visibleCards);
        return prevIndex >= maxIndex ? 0 : prevIndex + 1;
      });
    }, 2500); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, visibleCards]);
  return (
    <>
      <style>{`
        @media (min-width: 768px) {
          .animate-section[data-section-index="0"] {
            opacity: 0;
            transform: translateY(50px) scale(0.95);
            transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          }
          .animate-section[data-section-index="0"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateX(-40px) rotateY(5deg);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(60px) scale(0.9);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(70px) scale(0.92);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(55px) scale(0.96);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateX(35px) rotateY(-3deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(45px) scale(0.97);
            transition: all 0.5s ease-out 0.7s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateX(-30px) rotateY(4deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(40px) scale(0.98);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.9s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="9"] {
            opacity: 0;
            transform: translateX(25px) rotateY(-2deg);
            transition: all 0.5s ease-in-out 0.7s;
          }
          .animate-section[data-section-index="9"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
        }
        @media (max-width: 767px) {
          .animate-section[data-section-index="0"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease;
          }
          .animate-section[data-section-index="0"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.1s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.2s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.3s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.4s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.5s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.6s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.7s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.8s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="9"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.9s;
          }
          .animate-section[data-section-index="9"].visible {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .btn {
          transition: all 0.3s ease;
          transform: translateY(0);
        }
        .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(226, 114, 57, 0.4);
        }
        .card {
          transition: all 0.3s ease;
        }
        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .services-hover-effect {
          transition: all 0.3s ease;
        }
        .services-hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }
      `}</style>
      <section className="hero-section text-center">
        <div
          className={`about_bg d-flex align-items-center justify-content-center animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >
          <div className="row mx-auto mt-lg-5 mt-5">
            <div className="col-12 text-center">
              <h1 className="about_font text-white fw-bold" >
                Simplify Internal Medicine Billing with<br /> Proven RCM Expertise
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                Enhance your practice operations with internal medicine billing services tailored to simplify workflows, ensure regulatory compliance,
                <br /> and drive stronger financial outcomes so you can focus more on patient care, not paperwork.
              </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-5 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={() => { handleCTAClick('hero_section'); handleShow(); }} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>
          </div>
        </div>
        <div
          className={`boost_main_clie position-relative animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[1] = el}
          data-section-index="1"
        >
          <div className='container pt-lg-4'>
            <div className='row py-md-5 py-4'>
              <div className='col-lg-6'>
                <div className='row mx-auto'>
                  <div className='col-12'>
                    <img src={internal} alt='Specialized Internal Medicine Revenue Cycle Solutions with a Personalized Approach' className='twogroup_imgs' />
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='row'>

                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-3 mt-md-0'>
                    <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold'>
                      Specialized Internal Medicine Revenue Cycle Solutions with a Personalized Approach                   </h2>
                  </div>
                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-3'>
                    <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font'>
                      Precision-Focused Solutions for Internal Medicine Providers                                  </h3>
                  </div>
                  <div className='col-12 d-flex align-items-start justify-content-start mt-md-3 mb-md-3 mt-3'>
                    <p className='mb-0 text_justify_para'>
                      At{" "}
                      <a
                        href="https://probillrcm.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                      >
                        ProBill RCM
                      </a>
                      , we specialize in delivering end-to-end internal medicine billing services that drive revenue growth, streamline operations, and reduce administrative complexity. Our team understands the unique demands of internal medicine, including managing chronic conditions, preventive care, and complex documentation, and we tailor our RCM strategies to meet those specific needs.
                      <br />
                      With a focus on compliance, accuracy, and financial clarity, we partner with internal medicine practices to ensure cleaner claims, faster reimbursements, and long-term billing success.
                    </p>
                  </div>
                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-3 mt-md-0 pe-0 mb-0'>
                    <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font'>
                      Our Internal Medicine Billing & RCM Services Include:                                                                        </h3>
                  </div>

                  <div className='col-12  mt-md-4 mb-md-0 mb-4 mt-3 '>
                    <p className='mb-3 d-flex align-items-start justify-content-start text-start'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Accurate Billing & Coding for chronic care, annual wellness visits, E/M services, and diagnostic procedures                                                   </p>
                    <p className='mb-3 d-flex align-items-start justify-content-start text-start'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Internal Medicine-Specific Compliance Support to keep your practice aligned with ever-evolving regulations                                           </p>
                    <p className='mb-0 d-flex align-items-start justify-content-start text-start'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Custom Reporting & Performance Analytics to reveal growth opportunities and drive data-backed decisions                                                     </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className='boost_main_client boost_main_client_two position-absolute'>
            <img src={clients} alt='' />
          </div>
        </div>
        {/* <div
          className={`container mt-0 animate-section ${animatedSections.has(2) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[2] = el}
          data-section-index="2"
        >
          <div className='row mx-auto'>
            <div className='col-12 add_border_bottom pb-md-4 pb-3 text-md-start text-center px-0'>
              <h3 className='mb-0 add_driving_font fw-semibold'>
                Internal Medicine <span className='add_grident_font'> Expertise</span>
              </h3>
            </div>
            <div className='col-12'>
              <div className='row'>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-4 pb-md-5 pb-0'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        15+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        Years of Experience
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-4 pb-md-5 pb-0'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        2000+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        Team Members
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-md-4 pt-0 pb-md-5 pb-4'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        $2.7B+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        In Payments
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-md-4 pt-0 pb-md-5 pb-4'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        $20B+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        In Charges
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div
          className={`bg_blue_vertical py-5 mx-auto d-flex align-items-center justify-content-center animate-section ${animatedSections.has(3) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[3] = el}
          data-section-index="3"
        >
          <div className='container py-lg-5'>
            <div className='row'>
              <div className='col-12 '>
                <div className='row border-bottom pb-md-5 pb-4'>
                  <div className='col-12 col-md-6 '>
                    <h2 class="mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold text-white text-start">Internal Medicine Sync™: Automated Clinical Record-Keeping for Smarter Practices </h2>
                  </div>
                  <div className='col-12 col-md-6 mt-3 mt-md-0'>
                    <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white">Simplify documentation and boost care delivery with Internal Medicine Sync™a secure, cloud-based clinical record-keeping solution designed specifically for internists and primary care teams. Reduce administrative workload, streamline care coordination, and ensure real-time access to accurate, compliant documentation across all patient touchpoints. </p>
                  </div>
                </div>
              </div>
              <div className='col-12 pt-md-0 pt-4'>
                <div className='row'>
                  {/* <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-0 pe-0 mb-3 mb-md-0'>
                    <h6 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font text-white'>
                      Core Features of Internal Medicine Sync™                                                                       </h6>
                  </div> */}
                  <div className='col-md-6 col-12  mt-md-5 mb-md-4'>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Access patient records securely anytime even without internet connectivity.                                                                                                 </p>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Automate clinical documentation for routine exams, chronic disease management, and preventive care.
                    </p>
                    <p className='mb-md-0 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Streamline the entire intake process from patient check-in to diagnostics and follow-up care.                                                        </p>
                  </div>
                  <div className='col-md-6 col-12  mt-md-5 mb-md-4'>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Customize the platform to fit solo physicians, group internal medicine practices, or multi-specialty clinics.                   </p>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Send complete and compliant documentation directly to your billing team for faster claim submission and improved RCM efficiency.                   </p>
                    <p className='mb-0 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Monitor clinical outcomes and financial health with real-time dashboards and performance analytics.                                                       </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`about-bg-img p-lg-1 mt-lg-0 position-relative animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[4] = el}
          data-section-index="4"
        >
          <div class="boost_main_client_right boost_main_client_right_tranform_text2 position-absolute d-md-flex d-none">
            <img src="/static/media/workright.9f2dd025b6ec7c8f6511.webp" alt="" /></div>
          <div className="about-bg-img2 py-md-5 py-0">
            <div className="container p-lg-2 py-lg-0 mb-lg-4  mt-4 mt-lg-4">
              <div className="row">
                <div className="col-12 col-lg-6 pe-md-5">
                  <img src={twoperson} className='img-fluid mt-1 w-100 about-left-img' alt="behavioral & mental health billing services" />
                </div>
                <div className="col-12 col-lg-6 ">
                  <div className="div text-start mt-3 mt-md-0">
                    <div className='col-12'>
                      <h2 className="mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold text-dark text-start">
                        Why Internal Medicine Practices Need Expert RCM Support
                      </h2>
                    </div>
                    <div className='col-12 mt-3'>
                      <p className="mb-0 d-flex align-items-start justify-content-start text-start about-first-desc">
                        Outsourcing billing and revenue cycle management offers key advantages for internal medicine providers:
                      </p>
                    </div>

                    <div className="d-flex mt-lg-3 mt-3">
                      <div className='number-bg-img one p-lg-3 mt-lg-0 mt-3 text-lg-center'></div>
                      <div className="div ms-lg-2 d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}>
                          <span className='fw-bold text-dark'>Ensure billing accuracy</span> with specialty-specific codes for chronic care, preventive screenings, and diagnostic services.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mt-2 mt-lg-3">
                      <div className='number-bg-img1 one p-lg-3 text-lg-center mt-lg-1 mt-3'></div>
                      <div className="div ms-lg-1 d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}>
                          <span className='fw-bold text-dark'>Maintain compliance</span> with evolving Medicare, Medicaid, and commercial payer regulations.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mt-2 mt-lg-3 mb-lg-0 mb-2">
                      <div className='number-bg-img2 one p-lg-3 text-lg-center mt-lg-0 mt-3'></div>
                      <div className="div ms-lg-1 d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}>
                          <span className='fw-bold text-dark'>Optimize administrative workflows</span> to reduce time spent on billing and improve clinical focus.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mt-2 mt-lg-3 mb-lg-0 mb-2">
                      <div className='number-bg-img3 one p-lg-3 text-lg-center mt-lg-0 mt-3'></div>
                      <div className="div ms-lg-1 d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}>
                          <span className='fw-bold text-dark'>Accelerate reimbursements</span> with faster claim submissions and fewer denials.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mt-2 mt-lg-3 mb-lg-0 mb-3">
                      <div className='number-bg-img4 one p-lg-3 text-lg-center mt-lg-0 mt-3'></div>
                      <div className="div ms-lg-1 d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}>
                          <span className='fw-bold text-dark'>Gain expert support</span> from billing professionals who understand internal medicine’s complex care models.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <section
          className={`pb-md-0 pb-0 px-0 px-md-5 add_border_radius_second bg_light_img_add py-lg-5 animate-section ${animatedSections.has(5) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[5] = el}
          data-section-index="5"
        >
          <div className="container px-0 px-md-0 py-md-4 py-4 ">
            <div className="row justify-content-center mx-auto">



              <div className='col-12 d-flex align-items-center justify-content-center'>
                <h2 className='mb-md-0 mb-2 d-md-flex d-none align-items-center justify-content-center add_font_head fw-semibold'>
                  Scalable Billing Services Designed  <br /> for Internal Medicine                              </h2>
                <h4 className='mb-md-0 mb-2 d-md-none d-block align-items-center justify-content-center add_font_head fw-semibold mt-0'>
                  Scalable Billing Services Designed for Internal Medicine                              </h4>
              </div>

              <div className="col-12 mt-md-5 mt-2 px-1 px-md-0">
                <div className="row mx-auto">
                  {practiceSettings.map((item, index) => (
                    <div key={index} className="col-12 col-md-4 mb-md-2 mb-3 d-flex">
                      <div
                        className="w-100 p-md-4 p-3 bg-white shadow-sm rounded-4 position-relative h-100  add_bg_color_card services-hover-effect d-flex flex-column align-items-center justify-content-between"
                        onClick={() => handlePracticeSettingClick(item.title)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-center mb-md-3 mb-0 justify-content-between col-12">
                          <img
                            src={item.icon}
                            alt={item.alt}
                            style={{ width: "70px", height: "70px", objectFit: "contain" }}
                            className="me-3 image_width_data_icon_small"
                          />
                          <span className="add_num_font fw-semibold">{item.number}</span>
                        </div>
                        <div className='col-12'>                                                <h3 className="add_font_another mb-0 fw-semibold text-start mt-2">{item.title}</h3>
                        </div>
                        <div className='col-12'>                                                <p className="mb-0 add_font_card_para_data text-start mt-1">{item.description}</p>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className={`position-relative animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[6] = el}
          data-section-index="6"
        >
          <img src={dottesti} alt='' className='position-absolute add_set_position' />
          <div className="container mt-lg-0 mt-0 card-bg-vector">
            <div className="row mx-auto mt-lg-4">
              <div className="col-lg-8 col-12 m-0 mt-lg-5 text-start">
                <h2 className=" text-dark text-probill-rcm m-0 mt-lg-0 mt-4 ">Our Positive <span className="text-probill-rcm-orange add_grident_font">Social Impact</span></h2>
                <p className='mt-lg-3 mt-1 text-probill-para m-0 d-md-block d-none'>Partnering with us has helped internal medicine providers streamline operations, improve <br />collections, and focus more on delivering quality patient care.</p>
                <p className='mt-lg-3 mt-1 text-probill-para m-0 d-block d-md-none'>Partnering with us has helped internal medicine providers streamline operations, improve collections, and focus more on delivering quality patient care.</p>
              </div>
              <div className="col-lg-4 mt-lg-5 mt-3 col-12 text-lg-end text-center">
                {/* <h5 className='me-0 fw-semibold mb-2' style={{ fontSize: "24px", lineHeight: "40px" }}><img src={onestart} alt="" style={{ width: "27px", height: "27px" }} /> Trustpilot</h5> */}
                <div className="d-flex justify-content-lg-end justify-content-center align-items-end">
                  <div className="d-flex justify-content-between ">

                    <div className="div star mx-1 d-flex align-item-center ">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center me-0">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>

                  </div>
                </div>
                {/* <p className='my-0' style={{ fontSize: "14px", lineHeight: "40px", color: "#474d5cff" }}>Trust Score 5.0 | 3,724 reviews</p> */}
              </div>
            </div>

          </div>
          <div className="container-fluid  mt-lg-0">
            <div className="row mx-auto card-bg-vect">
              <div className="quote-symbol-container px-5" style={{ position: 'absolute', left: 0, top: "0px", zIndex: 0, }}>
                <img src={card_vector} className="quote-symbol" alt="quote" />
                <img src={card_vector} className="quote-symbol" alt="quote" />
              </div>

              <div
                className="container-fluid mt-lg-5 animate-section"
                ref={containerRef}
                style={{ overflow: 'hidden', padding: '20px 0' }}
              >
                <div className="row mx-auto card-bg-vect" style={{ position: 'relative' }}>
                  <div
                    className="d-flex"
                    onMouseEnter={() => setIsAutoPlaying(false)}
                    onMouseLeave={() => setIsAutoPlaying(true)}
                    style={{
                      transform: `translateX(-${currentIndex * CARD_WIDTH}px)`,
                      transition: currentIndex >= testimonials.length ? 'none' : 'transform 0.5s ease-in-out',
                      gap: '16px',
                      willChange: 'transform',
                    }}
                  >
                    {infiniteTestimonials.map((testimonial, index) => (
                      <Card
                        key={`${testimonial.name}-${index}`}
                        className="h-100 slide-card"
                        style={{
                          borderRadius: '20px',
                          minWidth: `${CARD_WIDTH - 16}px`,
                          maxWidth: `${CARD_WIDTH - 16}px`,
                          flexShrink: 0,
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        }}
                      >
                        <Card.Body className="d-flex flex-column mt-md-4 mt-0 px-4">
                          <h3 className="text-start m-0 card-heading text-dark">{testimonial.title}</h3>
                          <Card.Text className="text-muted text-start insight-desc flex-grow-1">
                            {testimonial.quote}
                          </Card.Text>
                          <div className="d-flex align-items-center mt-3 mb-3">
                            <img
                              src={testimonial.img}
                              alt={testimonial.name}
                              className="rounded-5 me-3 card-user-img"
                              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                            />
                            <div className="text-start">
                              <h4 className="mb-0 text-dark m-0 card-user-name">{testimonial.name}</h4>
                              <span className="text-muted mb-0 card-rating">{testimonial.role}</span>
                            </div>
                            <div className="ms-auto mt-2 mx-0 align-items-center">
                              <div className="d-flex align-items-center">
                                <img
                                  src={onestart}
                                  alt="Star"
                                  className="m-0"
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <span
                                  className="ms-1 text-dark m-0"
                                  style={{ fontWeight: '600', fontFamily: 'poppins', fontSize: '16px' }}
                                >
                                  {testimonial.rating}
                                </span>
                              </div>
                              <span className="text-muted card-rating">Rating</span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </div>

                <div className="container mt-lg-5 mt-3">
                  <div className="row mx-auto mb-lg-5 mb-3">
                    <div className="d-flex col-lg-12 col-12 gap-2 align-items-center justify-content-center">
                      <Button
                        onClick={() => { trackEvent('click', 'Internal Medicine Testimonials', 'Previous', 'testimonials_section'); handlePrev(); }}
                        disabled={currentIndex === 0}
                        className="btn fw-bold bg-white rounded-5 text-dark border-white shadow "
                      >
                        <i className="bi bi-arrow-left fw-bold"></i>
                      </Button>
                      <Button
                        onClick={() => { trackEvent('click', 'Internal Medicine Testimonials', 'Next', 'testimonials_section'); handleNext(); }}
                        disabled={currentIndex >= testimonials.length - visibleCards}
                        className="btn bg-white text-dark border-white shadow fw-bold"
                      >
                        <i className="bi bi-arrow-right"></i>
                      </Button>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className={`pb-md-0 pb-0 px-0 px-md-5 position-relative animate-section ${animatedSections.has(7) ? 'visible' : ''}`}
          style={{ background: "#F5F5F5" }}
          ref={el => sectionRefs.current[7] = el}
          data-section-index="7"
        >
          <div className='boost_main_client boost_main_client_two_next position-absolute'>
            <img src={clients} alt='' />
          </div>
          <div className="container px-2 px-md-0 py-md-5 py-4">
            <div className="row justify-content-center mx-auto py-lg-4">


              <div className='col-12 d-flex flex-column align-items-center justify-content-start'>
                <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold d-md-block d-none'>
                  Internal Medicine Billing, RCM,  <br />and Practice Solutions

                </h2>
                <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold d-block d-md-none mt-0'>
                  Internal Medicine Billing, RCM, and Practice Solutions

                </h2>
                <p class="mb-0 text-dark add_para_font fw-medium d-md-block d-none">Our internal medicine billing specialists deliver end-to-end revenue cycle management services covering  <br />everything from EHR integration to compliance-driven consulting.</p>
                <p class="mb-0 text-dark add_para_font fw-medium d-block d-md-none">Our internal medicine billing specialists deliver end-to-end revenue cycle management services covering everything from EHR integration to compliance-driven consulting.</p>
              </div>

              <div className="col-12 mt-md-4 mt-2 px-0 px-md-0">
                <div className="row mx-auto">
                  {familyMedicineServices.map((service, index) => (
                    <div
                      key={index}
                      className="col-6 col-sm-12 col-md-4 position-relative mb-md-0 mb-0 p-2"
                    >
                      <div className="row h-100 mx-auto">
                        <div
                          className="col py-md-4 py-3 px-md-3 px-0 add_bg_color_card services-hover-effect bg-white shadow-sm"
                          onClick={() => handleServiceClick(service.title)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="row mx-auto">
                            <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-2 text-start text-md-start">
                              <img
                                src={service.icon}
                                alt={service.alt}
                                loading="lazy"
                                className="mb-0 mb-md-0 add_width_in_icons"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "contain"
                                }}
                              />
                            </div>
                            <div className="col-12 text-start mb-md-3 mb-2 pe-0">
                              <h3 className="add_font_another mb-0 fw-semibold text-start">
                                {service.title}
                              </h3>
                            </div>
                            <div className="col-12 text-start">
                              <p className="mb-0 add_font_card_para_data">
                                {service.description}
                              </p>
                            </div>
                            {/* <div className="col-12 text-end">
                            <p className="mb-0 add_font_card_para_data d-flex align-items-center justify-content-end add_grident_font fw-bold">
                              Learn More <i className="bi bi-arrow-right-short fs-3 ms-1"></i>
                            </p>
                          </div> */}

                          </div>
                        </div>
                      </div>
                      <img
                        src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                        alt=""
                        className="add_position_card_img position-absolute"
                        loading="lazy"
                      />
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className={`container about_bg_blue my-md-5 my-4 animate-section py-md-4 py-0 ${animatedSections.has(8) ? 'visible' : ''}`}
          style={{ borderRadius: "36px" }}
          ref={el => sectionRefs.current[8] = el}
          data-section-index="8"
        >
          <div className="row mx-auto mt-0 mt-lg-0 py-md-5 py-4">
            <div className="col-lg-9 mx-auto m-0 col-12  mt-0 pb-3 text-lg-center flex-column d-flex justify-content-center">
              <h3 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-md-block d-none'>
                Maximize Internal Medicine Revenue with<br /> Specialized RCM Insight             </h3>
              <h2 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-md-none d-block'>
                Maximize Internal Medicine Revenue with Specialized RCM Insight             </h2>
              <p className=' any-para mt-3 mt-lg-3 mb-0' style={{ color: 'rgba(255, 255, 255, 1)' }}>Internal medicine practices face unique billing challenges due to complex patient needs and a wide range of services. Our team specializes in identifying hidden revenue gaps in internal medicine billing in over 95% of evaluations, we uncover missed reimbursement opportunities.
                From chronic care management to evaluation and management (E/M) coding, our data-driven analysis pinpoints inefficiencies and boosts revenue accuracy. Your focus is patient care. Let our RCM experts ensure you’re getting paid for every service you provide.   </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-2'>
              <button
                className="btn add_padding_font"
                onClick={() => { handleCTAClick('revenue_gaps_section'); handleShow(); }} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>


          </div>
        </div>



        <section
          className={`faq-section pb-md-5 pb-4 position-relative animate-section ${animatedSections.has(9) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[9] = el}
          data-section-index="9"
        >
          <Container>
            <Row className="align-items-center py-md-4 py-0 mx-auto">
              <Col lg={6} className="d-flex gap-3 justify-content-center flex-wrap ps-lg-5">

                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center">
                  <h2 className='text-black contact-text  m-0 mt-lg-0 mt-2'>
                    Frequently Asked Questions
                  </h2>
                  <p className=' any-para mt-3 mt-lg-4 mb-3'>Everything Internal Medicine Practices Need to Know About Our RCM Services. </p>


                </div>
              </Col>
              <Col lg={6} className="pe-lg-6 px-3 py-2" style={{ border: "1px solid #c0c3ccff", borderRadius: "12px" }}>
                <div className="accordion" id="accordionExample">

                  {/* Accordion Item 1 */}
                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingOne">
                      <button className="accordion-button add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        What RCM services does ProBill offer for internal medicine practices?
                        <span className="accordion-icon ms-auto">
                          {/* Icons */}
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        We offer comprehensive revenue cycle management including coding, billing, claims management, denial resolution, credentialing, and financial reporting all tailored to the needs of internal medicine practices. We also provide consulting to optimize workflow and compliance.
                      </div>
                    </div>
                  </div>

                  {/* Accordion Item 2 */}
                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        How can ProBill help my practice capture more revenue?
                        <span className="accordion-icon ms-auto">
                          {/* Icons */}
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Through detailed audits and performance analytics, we identify missed revenue opportunities in your E/M coding, chronic care management, annual wellness visits, and other commonly underutilized services. Our goal is to ensure accurate and complete reimbursement for every patient encounter.
                      </div>
                    </div>
                  </div>

                  {/* Accordion Item 3 */}
                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Does ProBill handle coding for complex visits and chronic care?
                        <span className="accordion-icon ms-auto">
                          {/* Icons */}
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Yes. Our certified coders specialize in internal medicine and understand the nuances of coding for high-complexity visits, chronic condition management, preventive services, and time-based billing. We also help practices stay compliant with evolving CMS guidelines.
                      </div>
                    </div>
                  </div>

                  {/* Accordion Item 4 */}
                  <div className="accordion-item border-0">
                    <h3 className="accordion-header" id="headingFour">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Can you integrate with our existing EHR/PM system?
                        <span className="accordion-icon ms-auto">
                          {/* Icons */}
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Absolutely. We work with most major EHR and practice management systems used by internal medicine practices. Our team ensures smooth data transfer and workflow alignment to minimize disruption and maximize productivity.
                      </div>
                    </div>
                  </div>

                </div>
              </Col>

            </Row>


          </Container>
          {/* <div class="boost_main_client boost_main_client_tranform position-absolute"><img src={clients} alt="" /></div> */}
          <div class="boost_main_client_right boost_main_client_right_tranform_texti position-absolute"><img src={workright} alt="" /></div>
        </section>
        <Modal show={showModal} onHide={handleClose} centered size='xl'>
          {/* Close Button in Top-Right Corner */}
          <button
            type="button"
            className="btn-close position-absolute"
            style={{
              top: "11px",
              right: "11px",
              zIndex: 1051,
              backgroundColor: "#fff",
              borderRadius: "50%",
              padding: "6px",
              fontSize: "15px",
              // border: "2px solid black",
            }}
            aria-label="Close"
            onClick={handleClose}
          ></button>

          <Modal.Body className="p-4">
            <div className="container-fluid">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-6 d-none d-lg-block">
                  <div className="image-container">
                    <img
                      src={external1}
                      alt="Team Working"
                      className="w-100 h-100 diagonal-image"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                  {isSubmitted ? (
                    <div className="text-center">
                      <h1 className="hero-text mt-0">
                        Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                      </h1>
                      <p>for submitting your information! Our representative will reach out to you shortly.</p>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex m-0 modal-heading justify-content-between">
                        <h1>
                          How can we <span style={{ color: "#E27239" }}>help you?</span>
                        </h1>
                        {/* Remove this old close button if not needed */}
                        {/* <button
                                          type="button"
                                          className="btn-close d-lg-none d-block"
                                          onClick={handleClose}
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                      ></button> */}
                      </div>
                      <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                        Within 24 hours, a representative from our company will contact you.
                      </p>
                      <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-medium text-start d-block">Name</label>
                            <input
                              type="text"
                              placeholder="Enter your Full Name"
                              className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("fullName", { required: "Full Name is required" })}
                            />
                            {errors.fullName && (
                              <p className="text-danger">{errors.fullName.message}</p>
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-medium text-start d-block">Email</label>
                            <input
                              type="email"
                              placeholder="Enter your Email"
                              className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                  message: "Please enter a valid email address"
                                }
                              })}
                            />
                            {errors.email && (
                              <p className="text-danger">{errors.email.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mb-3">
                            <label className="form-label fw-medium text-start d-block">Subject</label>
                            <input
                              type="text"
                              placeholder="Enter Subject"
                              className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("subject", {
                                required: "Subject is required",
                                minLength: {
                                  value: 3,
                                  message: "Subject should be at least 3 characters long"
                                }
                              })}
                            />
                            {errors.subject && (
                              <p className="text-danger">{errors.subject.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mb-3">
                            <label className="form-label fw-medium text-start d-block">Message</label>
                            <textarea
                              className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480" }}
                              rows="7"
                              placeholder="Brief us on your requirements"
                              {...register("message", {
                                required: "Message is required",
                                minLength: {
                                  value: 10,
                                  message: "Message should be at least 10 characters long"
                                }
                              })}
                            ></textarea>
                            {errors.message && (
                              <p className="text-danger">{errors.message.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mt-3">
                            <button
                              type="submit"
                              className="btn col-12"
                              style={{
                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                color: "white",
                                borderRadius: "12px",
                                padding: "12px 24px",
                                border: "none",
                                fontWeight: "500",
                                fontSize: "16px"
                              }}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "SENDING..." : "Submit Now"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default InternalMedicine;
